import React, { Component } from "react";
import { connectStore } from "redux-box";
import { module as ui } from "@st/ui";
import { module as platform } from "@st/platform";
import { id as modalIds } from "@c/common/GlobalModal";
import {
  MainBodyContentContainer,
  PlusButton,
  PlusIcon,
  InfiniteScrollParentContainer,
  InfiniteScrollLoader
} from "@sc/custom.styled";
import InfiniteScroll from "react-infinite-scroller";
import {
  Title,
  SectionHeader,
  SectionSubtext,
  ContentArea,
  CardGrid,
  Card,
  CardTitle,
  CardMeta,
  CardFooter,
  EditIcon,
  EmptyState,
  LoadingState
} from "./PlatformView.styled";

class PlatformView extends Component {
  componentDidMount() {
    this.props.platform.requestPlatformList(0);
    this.props.platform.requestContentPolicySchema();
  }

  fetchMorePlatforms = () => {
    const { platform } = this.props;
    if (platform.has_more) {
      setTimeout(() => {
        if (platform.next_page > 0) {
          platform.requestConcatPlatformList(platform.next_page);
        }
      }, 300);
    }
  };

  openCreateModal = () => {
    const { ui, platform } = this.props;
    platform.clearPlatformFormState();
    platform.setActivePlatform(null);
    platform.setPlatformEditMode(false);
    ui.showModal(modalIds.PLATFORM_FORM);
  };

  openEditModal = (item) => {
    const { ui, platform } = this.props;
    platform.clearPlatformFormState();
    platform.setActivePlatform(item);
    platform.setPlatformEditMode(true);
    ui.showModal(modalIds.PLATFORM_FORM);
  };

  getPolicyRuleCount = (item) => {
    const policy = item.content_policy || {};
    return Object.values(policy).reduce((sum, rules) => sum + (rules ? rules.length : 0), 0);
  };

  render() {
    const { platforms, platforms_loading: loading, has_more } = this.props.platform;

    return (
      <MainBodyContentContainer primary>
        <SectionHeader>
          <div>
            <Title>Platforms</Title>
            <SectionSubtext>
              Configure per-platform content policies to control what children see.
            </SectionSubtext>
          </div>
        </SectionHeader>

        <ContentArea>
          {loading && platforms.length === 0 ? (
            <LoadingState>Loading platforms...</LoadingState>
          ) : platforms.length > 0 ? (
            <InfiniteScrollParentContainer
              noTop
              position="relative"
              height="calc(100vh - 200px)"
              style={{ paddingBottom: '80px' }}
            >
              <InfiniteScroll
                pageStart={0}
                loadMore={this.fetchMorePlatforms}
                hasMore={has_more}
                style={{ position: "relative" }}
                loader={
                  <InfiniteScrollLoader className="loader" key={0}>
                    <img
                      alt="loader"
                      width="50"
                      height="50"
                      src={require("static/img/Theme-loader.gif")}
                    />
                  </InfiniteScrollLoader>
                }
                useWindow={false}
              >
                <CardGrid>
                  {platforms.map((item) => {
                    const ruleCount = this.getPolicyRuleCount(item);
                    return (
                      <Card key={item.id}>
                        <EditIcon
                          className="fa fa-pencil"
                          onClick={() => this.openEditModal(item)}
                        />
                        <CardTitle>{item.name}</CardTitle>
                        <CardMeta>
                          <strong>Content Policy:</strong>{" "}
                          {ruleCount === 0
                            ? "Unrestricted (default)"
                            : `${ruleCount} rule${ruleCount !== 1 ? "s" : ""} configured`}
                        </CardMeta>
                        <CardFooter>
                          <span>ID: {item.id}</span>
                        </CardFooter>
                      </Card>
                    );
                  })}
                </CardGrid>
              </InfiniteScroll>
            </InfiniteScrollParentContainer>
          ) : (
            <EmptyState>No platforms found.</EmptyState>
          )}
        </ContentArea>

        <PlusButton hide={this.props.ui.show_modal} onClick={this.openCreateModal}>
          <PlusIcon
            primary
            alt="Plus Icon"
            cross={false}
            src={require("static/img/plusicon.png")}
          />
        </PlusButton>
      </MainBodyContentContainer>
    );
  }
}

export default connectStore({
  ui,
  platform,
})(PlatformView);
